window.addEventListener('open-new-tab', ({ detail }) => {
    const target = window.innerWidth <= 640 ? '_self' : '_blank';

    window.open(detail.route, target);
});

window.openNewTab = () => ({});

